import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHelmetSafety, FaGear, FaCertificate } from "react-icons/fa6";
import { useSelector } from "react-redux";
import PremiumPaywall from "@/components/PremiumPaywall.jsx";
import { PrimaryButton } from "@/components/Buttons.jsx";

export default function CRMAccessBlocker({ dismissAction = null, skipSettingsCheck = false }) {
  const navigate = useNavigate();
  const { selectedMerchant } = useSelector((state) => state.app);
  const crmSettings = useSelector((state) => state.crmSettings);

  let messages = {
    "enabling": {
      "title": "Almost there",
      "icon": <FaHelmetSafety className="text-4xl text-orange-500 dark:text-blue-400 mb-2" />,
      "message": "Please wait while we enable CRM for your account, this can take a few minutes.  You will be notified when it is ready."
    },
    "complete_settings": {
      "title": "Complete your settings",
      "icon": <FaGear className="text-4xl text-slate-500 dark:text-blue-400 mb-2" />,
      "message": "Please complete your CRM settings to start using these features.",
      "action": <PrimaryButton onClick={() => navigate("/crm/settings")}>See details</PrimaryButton>
    },
    "complete_domain_verification": {
      "title": "Complete domain verification",
      "icon": <FaCertificate className="text-4xl text-slate-500 dark:text-blue-400 mb-2" />,
      "message": "Please complete domain verification to enable CRM for your account.",
      "action": <PrimaryButton onClick={() => navigate("/crm/settings")}>See details</PrimaryButton>
    }
  }

  const handleDismiss = () => {
    if (dismissAction) {
      dismissAction();
    } else {
      navigate(-1);
    }
  };

  
  let message = null;
  if(!selectedMerchant) {
    return null;
  }
  if(!selectedMerchant.direct_addons?.includes("crm")) {
    return <PremiumPaywall requiresAddon={["crm"]} dismissAction={dismissAction} />
  }
  if(!selectedMerchant.mt_url) {
    message = messages.enabling;
  }else{
    if(skipSettingsCheck) {
      return null;
    }
    if(!crmSettings.defaultFromName) {
      message = messages.complete_settings;
    }else{
      if(!crmSettings.development_mode) {
        if(!crmSettings.domains.length) {
          message = messages.complete_settings;
        }else{
          if(!crmSettings.defaultFromName || !crmSettings.defaultFromAddress || !crmSettings.defaultReplyToAddress) {
            message = messages.complete_settings;
          }else if(!crmSettings.domains.some(domain => domain.status === "success")) {
            message = messages.complete_domain_verification;
          }
        }
      }
    }
  }

  if(!message) {
    return null;
  }


  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-md">
      <div className="bg-white dark:bg-theme-surface-accent p-4 rounded-lg flex flex-col items-center gap-4 relative max-w-md">
        <div className="relative w-full">
          <h2 className="text-lg font-bold text-center">{message.title}</h2>
          <button
            className="text-2xl absolute top-[-0.5em] right-1"
            onClick={handleDismiss}
          >
            &times;
          </button>
        </div>
        <div className="flex flex-col items-center gap-2">
          {message.icon}
          <p className="text-sm text-center">
            {message.message}
          </p>
        </div>
        {message.action}
      </div>
    </div>
  );
}